import React, { useState } from 'react';
import Nlayout from './Nlayout';
import { Grid } from '@mui/material';
import { motion, AnimatePresence } from 'framer-motion';
import { PiTipJarDuotone } from 'react-icons/pi';
import { FaCoins, FaTrophy, FaChevronDown, FaCheckCircle, FaExclamationTriangle, FaInfoCircle } from 'react-icons/fa';
import './Guias.css';

// ── Data ──────────────────────────────────────────────────
const categories = [
    {
        id: 'tipeos',
        name: 'Tipeos',
        icon: <PiTipJarDuotone />,
        iconClass: 'tipeos',
        description: 'Todo sobre como reclamar y recibir tus tipeos',
        guides: [
            {
                title: 'Cómo reclamar tipeos',
                content: (
                    <>
                        <p>Felicitaciones si estás acá es porque ganaste un tipeo y no sabes como reclamarlo.</p>
                        <p>Es muy sencillo, acá abajo voy a dejarte los pasos para generar tu solicitud.</p>

                        <div className="guia-paso paso-1">
                            <span className="guia-paso-label">Paso 1</span>
                            <p className="guia-paso-text">Ingresar a la sección <strong>TIPEOS</strong> en la página.</p>
                        </div>

                        <div className="guia-paso paso-2">
                            <span className="guia-paso-label">Paso 2</span>
                            <p className="guia-paso-text">Una vez dentro de la sección vas a ver en que casino ganaste el tipeo porque te va a figurar un botón o más en caso de haber ganado mas.</p>
                        </div>

                        <div className="guia-paso paso-3">
                            <span className="guia-paso-label">Paso 3</span>
                            <p className="guia-paso-text">Clickear el botón <strong>RECLAMAR TIPEO DE *</strong></p>
                        </div>

                        <div className="guia-paso paso-4">
                            <span className="guia-paso-label">Paso 4</span>
                            <p className="guia-paso-text">Seguir <strong>TODOS</strong> los pasos que dice la página, es fácil. Si en algún momento te sale la pantalla en negro intenta reclamar el tipeo en modo incógnito.</p>
                        </div>

                        <div className="guia-paso paso-5">
                            <span className="guia-paso-label">Paso 5</span>
                            <p className="guia-paso-text">Una vez generes la solicitud de tipeo tendrás que esperar un tiempo hasta que se te entregue el tipeo, generalmente eldenguee dice en que horario lo entrega. Una vez que los entregue te va a llegar un correo confirmando o denegando tu solicitud. Si hiciste todo bien te va a llegar sin problemas.</p>
                        </div>
                    </>
                ),
            },
            {
                title: 'Cómo reclamar tipeos extra',
                content: (
                    <>
                        <p>Cada vez que ganas un tipeo o lo compras en el shop tenes habilitado un tipeo extra. Pero para reclamarlo tenes que seguir unos pasos antes.</p>

                        <div className="guia-paso paso-1">
                            <span className="guia-paso-label">Paso 1</span>
                            <p className="guia-paso-text">Reclamar el primer tipeo en la sección <strong>TIPEOS</strong> de la web</p>
                        </div>

                        <div className="guia-paso paso-2">
                            <span className="guia-paso-label">Paso 2</span>
                            <p className="guia-paso-text">Esperar a que te llegue el correo de confirmación del primer <strong>TIPEO</strong></p>
                        </div>

                        <div className="guia-paso paso-3">
                            <span className="guia-paso-label">Paso 3</span>
                            <p className="guia-paso-text">Una vez que te llegue la confirmación del primer tipeo se te habilitará dentro de la sección <strong>TIPEOS</strong> de la web el botón para reclamar el <strong>TIPEO EXTRA</strong></p>
                        </div>

                        <div className="guia-paso paso-4">
                            <span className="guia-paso-label">Paso 4</span>
                            <p className="guia-paso-text">Clickear el botón y seguir los pasos, es muy fácil. Una vez se te confirme el tipeo extra y te llegue el correo podrás verificarlo y ganar <strong>D-COINS</strong>.</p>
                        </div>
                    </>
                ),
            },
            {
                title: 'Cuándo llegan los tipeos',
                content: (
                    <>
                        <div className="guia-highlight">
                            <FaInfoCircle style={{ marginRight: 8, flexShrink: 0 }} />
                            Los tipeos siempre se envían después de cada directo en el canal de Kick. En todos los directos eldenguee especifica el horario que se envían los tipeos comunes y luego los extras (se envían en 2 tandas distintas).
                        </div>
                    </>
                ),
            },
            {
                title: 'Errores típicos',
                content: (
                    <>
                        <div className="guia-error">
                            <FaExclamationTriangle className="guia-error-icon" />
                            <p className="guia-error-text">
                                Notamos que en algunos dispositivos cuando estás reclamando el tipeo algún paso hace que la pantalla quede toda en negra y no poder avanzar ni retroceder.
                            </p>
                        </div>
                        <div className="guia-solucion">
                            <FaCheckCircle className="guia-solucion-icon" />
                            <p className="guia-solucion-text">
                                <strong>Solución:</strong> Reclamar el tipeo en ventana de incógnito
                            </p>
                        </div>

                        <div style={{ height: 12 }} />

                        <div className="guia-error">
                            <FaExclamationTriangle className="guia-error-icon" />
                            <p className="guia-error-text">
                                Notamos que algunas personas se equivocan al poner su dirección BNB que le da la aplicación de LEMON.
                            </p>
                        </div>
                        <div className="guia-solucion">
                            <FaCheckCircle className="guia-solucion-icon" />
                            <p className="guia-solucion-text">
                                <strong>Solución:</strong> Usar el botón que hay dentro de la aplicación y pegarla exactamente igual.
                            </p>
                        </div>
                    </>
                ),
            },
        ],
    },
    {
        id: 'dcoins',
        name: 'D-COINS',
        icon: <FaCoins />,
        iconClass: 'dcoins',
        description: 'Todo sobre las D-COINS y cómo obtenerlas',
        guides: [
            {
                title: '¿Qué son las D-COINS?',
                content: (
                    <>
                        <p>Las <strong>D-COINS</strong> son monedas que se utilizan para canjear beneficios dentro del shop de la web, puedes obtenerlas de distintas maneras.</p>
                    </>
                ),
            },
            {
                title: '¿Cómo obtener D-COINS?',
                content: (
                    <>
                        <ul className="guia-list">
                            <li>
                                <strong>Verificando el depósito de tu TIPEO EXTRA</strong> puedes obtener <strong>1000 D-COINS</strong> para luego canjearlas en el shop por otro tipeo. Recuerda que es solo verificando el depósito de tu <strong>TIPEO EXTRA</strong>.
                            </li>
                            <li>
                                Puedes canjear puntos del canal en el chat <a href="https://kick.com/eldenguee" target="_blank" rel="noopener noreferrer" className="guia-link">https://kick.com/eldenguee</a> y automáticamente se te acreditarán los D-COINS en tu cuenta en ésta página.
                            </li>
                            <li>
                                Puedes jugar algunos <strong>juegos dentro de la página</strong> contra otras personas para ganar D-COINS.
                            </li>
                            <li>
                                Puedes ganar D-COINS saliendo entre los puestos <strong>(4-20)</strong> en el ranking diario del streaming.
                            </li>
                        </ul>
                    </>
                ),
            },
        ],
    },
    {
        id: 'rankings',
        name: 'Rankings',
        icon: <FaTrophy />,
        iconClass: 'rankings',
        description: 'Ranking de actividad y premios del streaming',
        guides: [
            {
                title: '¿Cómo funciona el ranking?',
                content: (
                    <>
                        <p>El ranking se activa cuando eldenguee prende directo en su canal de Kick.</p>

                        <div className="guia-highlight">
                            <strong>Es un ranking de actividad</strong> — por cada mensaje enviado en el chat (mensajes reales, no emotes, no spam) te suma en <strong>+1 mensaje</strong> en el ranking.
                        </div>

                        <p>Al finalizar el stream los primeros <strong>20 del ranking</strong> obtienen premio.</p>
                    </>
                ),
            },
            {
                title: 'Premios',
                content: (
                    <>
                        <div className="guia-paso paso-1">
                            <span className="guia-paso-label">🥇 Top 1-3</span>
                            <p className="guia-paso-text">Los primeros 3 se llevan una solicitud de tipeo en <strong>1xbet</strong>.</p>
                        </div>

                        <div className="guia-paso paso-3">
                            <span className="guia-paso-label">🏅 Top 4-20</span>
                            <p className="guia-paso-text">Los demás se llevan <strong>D-COINS</strong> para usar en el shop.</p>
                        </div>

                        <div className="guia-highlight">
                            Al finalizar el streaming se entregan los premios automáticamente.
                        </div>
                    </>
                ),
            },
        ],
    },
];

// ── Accordion Item ────────────────────────────────────────
const AccordionItem = ({ guide, index, isOpen, onToggle }) => {
    return (
        <div className={`guias-accordion-item ${isOpen ? 'open' : ''}`}>
            <button className="guias-accordion-header" onClick={onToggle}>
                <span className="guias-accordion-number">{index + 1}</span>
                <span className="guias-accordion-title">{guide.title}</span>
                <span className="guias-accordion-arrow">
                    <FaChevronDown />
                </span>
            </button>

            <AnimatePresence initial={false}>
                {isOpen && (
                    <motion.div
                        className="guias-accordion-body"
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: 'auto', opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.3, ease: [0.4, 0, 0.2, 1] }}
                    >
                        <div className="guias-accordion-body-inner">
                            {guide.content}
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
};

// ── Main Component ────────────────────────────────────────
function Guias({ isMobile }) {
    const [activeCategory, setActiveCategory] = useState('tipeos');
    const [openAccordion, setOpenAccordion] = useState(null);

    const currentCategory = categories.find(c => c.id === activeCategory);

    const handleCategoryChange = (id) => {
        setActiveCategory(id);
        setOpenAccordion(null);
    };

    const handleToggleAccordion = (index) => {
        setOpenAccordion(openAccordion === index ? null : index);
    };

    return (
        <Nlayout>
            <Grid className="guias-page">
                {/* Hero */}
                <div className="guias-hero">
                    <p className="guias-hero-label">Centro de Ayuda</p>
                    <h1 className="guias-hero-title">Guías</h1>
                    <p className="guias-hero-subtitle">
                        Todo lo que necesitas saber sobre tipeos, D-COINS y rankings. Encontrá las respuestas a tus preguntas acá.
                    </p>
                </div>

                {/* Layout: Sidebar + Content */}
                <div className="guias-layout">
                    {/* Sidebar */}
                    <div className="guias-sidebar">
                        <p className="guias-sidebar-title">Categorías</p>
                        <div className="guias-category-list">
                            {categories.map((cat) => (
                                <button
                                    key={cat.id}
                                    className={`guias-category-btn ${activeCategory === cat.id ? 'active' : ''}`}
                                    onClick={() => handleCategoryChange(cat.id)}
                                >
                                    <span className={`guias-category-icon ${cat.iconClass}`}>
                                        {cat.icon}
                                    </span>
                                    {cat.name}
                                    <span className="guias-category-count">{cat.guides.length}</span>
                                </button>
                            ))}
                        </div>
                    </div>

                    {/* Content */}
                    <div className="guias-content">
                        <AnimatePresence mode="wait">
                            <motion.div
                                key={activeCategory}
                                initial={{ opacity: 0, y: 16 }}
                                animate={{ opacity: 1, y: 0 }}
                                exit={{ opacity: 0, y: -16 }}
                                transition={{ duration: 0.25 }}
                            >
                                <div className="guias-content-header">
                                    <span className={`guias-content-icon guias-category-icon ${currentCategory.iconClass}`}>
                                        {currentCategory.icon}
                                    </span>
                                    <div>
                                        <h2 className="guias-content-title">{currentCategory.name}</h2>
                                        <p className="guias-content-desc">{currentCategory.description}</p>
                                    </div>
                                </div>

                                <div className="guias-accordion-list">
                                    {currentCategory.guides.map((guide, idx) => (
                                        <AccordionItem
                                            key={idx}
                                            guide={guide}
                                            index={idx}
                                            isOpen={openAccordion === idx}
                                            onToggle={() => handleToggleAccordion(idx)}
                                        />
                                    ))}
                                </div>
                            </motion.div>
                        </AnimatePresence>
                    </div>
                </div>
            </Grid>
        </Nlayout>
    );
}

export default Guias;
